import TrashComponent from './src/components/trash'
import ServiceComponent from './src/components/services'

export default {
   components: {
      
   },
   routes: [
      ...TrashComponent.routes,
      ...ServiceComponent.routes,
   ],
   sub_routes: [
      ...TrashComponent.sub_routes,
      ...ServiceComponent.sub_routes,
   ]
}

export const RegistryNav = [
   { 
      icon: 'fa fa-boxes',component: 'ServiceList', name: 'Services', has_permission: false
   },
   { 
      icon: 'fa fa-trash-alt',component: 'Trash', name: 'Trash', has_permission: false,
      children: [
         { icon: 'fa fa-columns',component: 'UserTrash', name: 'User Trash', resource: 'user', has_permission: false},
         // { icon: 'fa fa-columns',component: 'Roles', name: 'Roles', resource: 'role', has_permission: false},
      ]
   },
]